// extracted by mini-css-extract-plugin
export default {"heading":"style_heading__ipLnW","sign_sec":"style_sign_sec__a6wrP","sign_hero_wrap":"style_sign_hero_wrap__tLgGw","cont_form_wrap":"style_cont_form_wrap__Tugud"};